const LIVE_TLDS = ['sharefile.com', 'sharefile.eu', 'securevdr.com', 'citrixdata.com'];

export function getStripeKey(): string {
	const hostname = window.location.hostname.toLowerCase();

	const isLive = LIVE_TLDS.some(tld => hostname.endsWith(tld));

	return isLive
		? process.env.STRIPE_PUBLISHABLE_KEY_LIVE
		: process.env.STRIPE_PUBLISHABLE_KEY_TEST;
}
